import React from 'react';
import { Stack, Typography } from '@mui/material';
import SuggestionUndoButton from './suggestion-undo-button';

type Props = {
  onUndo: () => void;
};

/**
 * Marker shown in place of a field whose AI suggestion the user dismissed
 * during review. The undo link sits below the marker to match accepted
 * suggestion previews.
 */
const DismissedSuggestionRow = ({ onUndo }: Props) => (
  <Stack spacing={1}>
    <Typography variant="body" color="text.disabled">
      Suggestion skipped
    </Typography>
    <SuggestionUndoButton onClick={onUndo} />
  </Stack>
);

export default DismissedSuggestionRow;
